import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { OWNER } from "@/lib/api";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B1220]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <img src="/cel-horizontal.png" alt="Coastal Expedited Logistics" className="h-10 w-auto mb-5" />
        <p className="text-sm text-[#94A3B8] leading-relaxed">
          The operating system for carriers. Freight, dispatch, compliance, and startup support — all from Houston.
        </p>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Services</h4>
        <ul className="space-y-2.5 text-sm text-[#94A3B8]">
          <li><a href="/#services" className="hover:text-[#2563EB] transition-colors">Freight & Expedited</a></li>
          <li><a href="/#services" className="hover:text-[#2563EB] transition-colors">Dispatch & Marketplace</a></li>
          <li><a href="/#services" className="hover:text-[#2563EB] transition-colors">Filings & Compliance</a></li>
          <li><a href="/#services" className="hover:text-[#2563EB] transition-colors">Bookkeeping & Back-Office</a></li>
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Platform</h4>
        <ul className="space-y-2.5 text-sm text-[#94A3B8]">
          <li><Link to="/loads" className="hover:text-[#2563EB] transition-colors">Load Board</Link></li>
          <li><Link to="/portal" className="hover:text-[#2563EB] transition-colors">Shipper Portal</Link></li>
          <li><a href="/#startup" className="hover:text-[#2563EB] transition-colors">Start a Company</a></li>
          <li><Link to="/admin" className="hover:text-[#2563EB] transition-colors">Admin</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-[#94A3B8]">
          <li className="flex items-start gap-2"><MapPin size={16} className="text-[#2563EB] mt-0.5 shrink-0" /> {OWNER.address}</li>
          <li className="flex items-center gap-2"><Phone size={16} className="text-[#2563EB]" /> {OWNER.phone}</li>
          <li className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-[#2563EB]" /> {OWNER.email}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 px-5 text-center text-xs text-[#64748b]">
      © {new Date().getFullYear()} Coastal Expedited Logistics · Houston, TX · MC/DOT Authority · 24/7 Dispatch
    </div>
  </footer>
);
